window.addEventListener('load', function() {
    
    const appstle_click = document.querySelectorAll('.appstle_subscription_wrapper_option input');
    if(appstle_click) {
        appstle_click.forEach(function(button) {
            button.addEventListener('click', function() {
                const find_bundle = document.getElementById('dynamic-pricing-bundle-custom-page');
                if(find_bundle) {
                    if(this.value) {
                        find_bundle.style.display = 'block';

                    }else {
                        find_bundle.style.display = 'none';
                    }
                }
            }); 
        });
    }
});